import { render, staticRenderFns } from "./specialRequest.vue?vue&type=template&id=d0a3870e&scoped=true&"
import script from "./specialRequest.vue?vue&type=script&lang=js&"
export * from "./specialRequest.vue?vue&type=script&lang=js&"
import style0 from "./specialRequest.vue?vue&type=style&index=0&id=d0a3870e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a3870e",
  null
  
)

export default component.exports